import { Link, Tooltip, Typography } from '@trustsecurenow/components-library';
import React from 'react';
import PropTypes from 'prop-types';
import { isNA } from '../helpers';
import { Link as RouterLink } from 'react-router-dom';

const ReceivedWelcomeMessageCell = ({ receiversPercent = '', onClick }) => {
  if (isNA(receiversPercent)) return <Typography variant="body2">N/A</Typography>;

  const color = receiversPercent < 75 ? 'error' : 'success';

  return (
    <Tooltip title="Click here to configure sending Welcome Message" placement="top">
      <Link
        color={`${color}.main`}
        underline="hover"
        hoverColor="info.main"
        variant="body2"
        onClick={onClick}
        component={RouterLink}
        to={false}
      >
        {`${receiversPercent}%`}
      </Link>
    </Tooltip>
  );
};

ReceivedWelcomeMessageCell.propTypes = {
  receiversPercent: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ReceivedWelcomeMessageCell;
